import { SessionLogsEnum } from './sessionLogs.enum';
/**
 * used to session log request model
 */
export class SessionLogRequestModel {

    logType: number;
    optionalStartDate: Date | number | string;
    optionalEndDate: Date | number | string;
    optionalLoginId: string;
    pageNo: number;
    recordsCount: number;
}